/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminBillingAggregateHistoryResponse } from '../models';
// @ts-ignore
import type { AdminBillingOrgEntry } from '../models';
// @ts-ignore
import type { AdminBillingOrgUpdateRequest } from '../models';
// @ts-ignore
import type { AdminBillingOrganizationsResponse } from '../models';
// @ts-ignore
import type { AdminBillingOverviewResponse } from '../models';
// @ts-ignore
import type { AdminCreateTopUpRequest } from '../models';
// @ts-ignore
import type { AdminOrgUsageListResponse } from '../models';
// @ts-ignore
import type { AggregationWindow } from '../models';
// @ts-ignore
import type { BillingBalanceResponse } from '../models';
// @ts-ignore
import type { BillingCyclesResponse } from '../models';
// @ts-ignore
import type { BillingHistoryResponse } from '../models';
// @ts-ignore
import type { BillingTopUpEntry } from '../models';
// @ts-ignore
import type { BillingTopUpListResponse } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * AdminBillingApi - axios parameter creator
 * @export
 */
export const AdminBillingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a top-up for an organization
         * @param {string} organizationId 
         * @param {AdminCreateTopUpRequest} adminCreateTopUpRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost: async (organizationId: string, adminCreateTopUpRequest: AdminCreateTopUpRequest, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost', 'organizationId', organizationId)
            // verify required parameter 'adminCreateTopUpRequest' is not null or undefined
            assertParamExists('createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost', 'adminCreateTopUpRequest', adminCreateTopUpRequest)
            const localVarPath = `/api/v1/admin/billing/organizations/{organization_id}/top-ups`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateTopUpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a top-up for an organization
         * @param {string} organizationId 
         * @param {AdminCreateTopUpRequest} adminCreateTopUpRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost_1: async (organizationId: string, adminCreateTopUpRequest: AdminCreateTopUpRequest, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost_1', 'organizationId', organizationId)
            // verify required parameter 'adminCreateTopUpRequest' is not null or undefined
            assertParamExists('createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost_1', 'adminCreateTopUpRequest', adminCreateTopUpRequest)
            const localVarPath = `/api/v1/admin/billing/organizations/{organization_id}/top-ups`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateTopUpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve aggregated billing history across all organizations.
         * @summary Get cross-organization billing history
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregateHistoryApiV1AdminBillingHistoryAggregateGet: async (startTime: string, endTime: string, window?: AggregationWindow, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getAggregateHistoryApiV1AdminBillingHistoryAggregateGet', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getAggregateHistoryApiV1AdminBillingHistoryAggregateGet', 'endTime', endTime)
            const localVarPath = `/api/v1/admin/billing/history/aggregate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve aggregated billing history across all organizations.
         * @summary Get cross-organization billing history
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregateHistoryApiV1AdminBillingHistoryAggregateGet_2: async (startTime: string, endTime: string, window?: AggregationWindow, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getAggregateHistoryApiV1AdminBillingHistoryAggregateGet_2', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getAggregateHistoryApiV1AdminBillingHistoryAggregateGet_2', 'endTime', endTime)
            const localVarPath = `/api/v1/admin/billing/history/aggregate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the credit balance for a specific organization. Optionally specify cycle_start to get historical balance.
         * @summary Get organization billing balance
         * @param {string} organizationId Target organization ID
         * @param {string | null} [cycleStart] Cycle start for historical balance (ISO 8601 UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceApiV1AdminBillingBalanceGet: async (organizationId: string, cycleStart?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBalanceApiV1AdminBillingBalanceGet', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/billing/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (cycleStart !== undefined) {
                localVarQueryParameter['cycle_start'] = (cycleStart as any instanceof Date) ?
                    (cycleStart as any).toISOString() :
                    cycleStart;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the credit balance for a specific organization. Optionally specify cycle_start to get historical balance.
         * @summary Get organization billing balance
         * @param {string} organizationId Target organization ID
         * @param {string | null} [cycleStart] Cycle start for historical balance (ISO 8601 UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceApiV1AdminBillingBalanceGet_3: async (organizationId: string, cycleStart?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getBalanceApiV1AdminBillingBalanceGet_3', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/billing/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (cycleStart !== undefined) {
                localVarQueryParameter['cycle_start'] = (cycleStart as any instanceof Date) ?
                    (cycleStart as any).toISOString() :
                    cycleStart;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all billing cycles for a specific organization, most recent first.
         * @summary List billing cycles
         * @param {string} organizationId Target organization ID
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCyclesApiV1AdminBillingCyclesGet: async (organizationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCyclesApiV1AdminBillingCyclesGet', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/billing/cycles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all billing cycles for a specific organization, most recent first.
         * @summary List billing cycles
         * @param {string} organizationId Target organization ID
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCyclesApiV1AdminBillingCyclesGet_4: async (organizationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCyclesApiV1AdminBillingCyclesGet_4', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/billing/cycles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve chartable credit usage history for a specific organization.
         * @summary Get organization billing history
         * @param {string} organizationId Target organization ID
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string | null} [agentId] Optional agent filter
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryApiV1AdminBillingHistoryGet: async (organizationId: string, startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getHistoryApiV1AdminBillingHistoryGet', 'organizationId', organizationId)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getHistoryApiV1AdminBillingHistoryGet', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getHistoryApiV1AdminBillingHistoryGet', 'endTime', endTime)
            const localVarPath = `/api/v1/admin/billing/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve chartable credit usage history for a specific organization.
         * @summary Get organization billing history
         * @param {string} organizationId Target organization ID
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string | null} [agentId] Optional agent filter
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryApiV1AdminBillingHistoryGet_5: async (organizationId: string, startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getHistoryApiV1AdminBillingHistoryGet_5', 'organizationId', organizationId)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('getHistoryApiV1AdminBillingHistoryGet_5', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('getHistoryApiV1AdminBillingHistoryGet_5', 'endTime', endTime)
            const localVarPath = `/api/v1/admin/billing/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of individual call usage records for a specific organization.
         * @summary Get organization call usage records
         * @param {string} organizationId 
         * @param {number} [limit] Page size
         * @param {number} [offset] Pagination offset
         * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortByEnum} [sortBy] Sort field
         * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortDirectionEnum} [sortDirection] asc or desc
         * @param {string | null} [startTime] Filter: only records with started_at &gt;&#x3D; this (UTC)
         * @param {string | null} [endTime] Filter: only records with started_at &lt; this (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet: async (organizationId: string, limit?: number, offset?: number, sortBy?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortByEnum, sortDirection?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortDirectionEnum, startTime?: string | null, endTime?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/billing/organizations/{organization_id}/usage`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of individual call usage records for a specific organization.
         * @summary Get organization call usage records
         * @param {string} organizationId 
         * @param {number} [limit] Page size
         * @param {number} [offset] Pagination offset
         * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortByEnum} [sortBy] Sort field
         * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortDirectionEnum} [sortDirection] asc or desc
         * @param {string | null} [startTime] Filter: only records with started_at &gt;&#x3D; this (UTC)
         * @param {string | null} [endTime] Filter: only records with started_at &lt; this (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet_6: async (organizationId: string, limit?: number, offset?: number, sortBy?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortByEnum, sortDirection?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortDirectionEnum, startTime?: string | null, endTime?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet_6', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/billing/organizations/{organization_id}/usage`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve paginated billing status for all organizations.
         * @summary Get per-organization billing status
         * @param {number} [limit] Page size
         * @param {number} [offset] Page offset
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsApiV1AdminBillingOrganizationsGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/billing/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve paginated billing status for all organizations.
         * @summary Get per-organization billing status
         * @param {number} [limit] Page size
         * @param {number} [offset] Page offset
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsApiV1AdminBillingOrganizationsGet_7: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/billing/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve aggregated billing metrics across all organizations.
         * @summary Get platform-wide billing overview
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverviewApiV1AdminBillingOverviewGet: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/billing/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve aggregated billing metrics across all organizations.
         * @summary Get platform-wide billing overview
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverviewApiV1AdminBillingOverviewGet_8: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/billing/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the top-up purchase ledger for a specific organization.
         * @summary Get organization top-up ledger
         * @param {string} organizationId Target organization ID
         * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
         * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopUpsApiV1AdminBillingTopUpsGet: async (organizationId: string, startTime?: string | null, endTime?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTopUpsApiV1AdminBillingTopUpsGet', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/billing/top-ups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the top-up purchase ledger for a specific organization.
         * @summary Get organization top-up ledger
         * @param {string} organizationId Target organization ID
         * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
         * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopUpsApiV1AdminBillingTopUpsGet_9: async (organizationId: string, startTime?: string | null, endTime?: string | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getTopUpsApiV1AdminBillingTopUpsGet_9', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/billing/top-ups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (startTime !== undefined) {
                localVarQueryParameter['start_time'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['end_time'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update organization billing allowance
         * @param {string} organizationId 
         * @param {AdminBillingOrgUpdateRequest} adminBillingOrgUpdateRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch: async (organizationId: string, adminBillingOrgUpdateRequest: AdminBillingOrgUpdateRequest, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch', 'organizationId', organizationId)
            // verify required parameter 'adminBillingOrgUpdateRequest' is not null or undefined
            assertParamExists('updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch', 'adminBillingOrgUpdateRequest', adminBillingOrgUpdateRequest)
            const localVarPath = `/api/v1/admin/billing/organizations/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminBillingOrgUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update organization billing allowance
         * @param {string} organizationId 
         * @param {AdminBillingOrgUpdateRequest} adminBillingOrgUpdateRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch_10: async (organizationId: string, adminBillingOrgUpdateRequest: AdminBillingOrgUpdateRequest, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch_10', 'organizationId', organizationId)
            // verify required parameter 'adminBillingOrgUpdateRequest' is not null or undefined
            assertParamExists('updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch_10', 'adminBillingOrgUpdateRequest', adminBillingOrgUpdateRequest)
            const localVarPath = `/api/v1/admin/billing/organizations/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminBillingOrgUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminBillingApi - functional programming interface
 * @export
 */
export const AdminBillingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminBillingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a top-up for an organization
         * @param {string} organizationId 
         * @param {AdminCreateTopUpRequest} adminCreateTopUpRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost(organizationId: string, adminCreateTopUpRequest: AdminCreateTopUpRequest, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingTopUpEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost(organizationId, adminCreateTopUpRequest, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a top-up for an organization
         * @param {string} organizationId 
         * @param {AdminCreateTopUpRequest} adminCreateTopUpRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost_1(organizationId: string, adminCreateTopUpRequest: AdminCreateTopUpRequest, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingTopUpEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost_1(organizationId, adminCreateTopUpRequest, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve aggregated billing history across all organizations.
         * @summary Get cross-organization billing history
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregateHistoryApiV1AdminBillingHistoryAggregateGet(startTime: string, endTime: string, window?: AggregationWindow, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBillingAggregateHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregateHistoryApiV1AdminBillingHistoryAggregateGet(startTime, endTime, window, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getAggregateHistoryApiV1AdminBillingHistoryAggregateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve aggregated billing history across all organizations.
         * @summary Get cross-organization billing history
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAggregateHistoryApiV1AdminBillingHistoryAggregateGet_2(startTime: string, endTime: string, window?: AggregationWindow, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBillingAggregateHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregateHistoryApiV1AdminBillingHistoryAggregateGet_2(startTime, endTime, window, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getAggregateHistoryApiV1AdminBillingHistoryAggregateGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the credit balance for a specific organization. Optionally specify cycle_start to get historical balance.
         * @summary Get organization billing balance
         * @param {string} organizationId Target organization ID
         * @param {string | null} [cycleStart] Cycle start for historical balance (ISO 8601 UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalanceApiV1AdminBillingBalanceGet(organizationId: string, cycleStart?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalanceApiV1AdminBillingBalanceGet(organizationId, cycleStart, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getBalanceApiV1AdminBillingBalanceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the credit balance for a specific organization. Optionally specify cycle_start to get historical balance.
         * @summary Get organization billing balance
         * @param {string} organizationId Target organization ID
         * @param {string | null} [cycleStart] Cycle start for historical balance (ISO 8601 UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBalanceApiV1AdminBillingBalanceGet_3(organizationId: string, cycleStart?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBalanceApiV1AdminBillingBalanceGet_3(organizationId, cycleStart, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getBalanceApiV1AdminBillingBalanceGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all billing cycles for a specific organization, most recent first.
         * @summary List billing cycles
         * @param {string} organizationId Target organization ID
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCyclesApiV1AdminBillingCyclesGet(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingCyclesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCyclesApiV1AdminBillingCyclesGet(organizationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getCyclesApiV1AdminBillingCyclesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all billing cycles for a specific organization, most recent first.
         * @summary List billing cycles
         * @param {string} organizationId Target organization ID
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCyclesApiV1AdminBillingCyclesGet_4(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingCyclesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCyclesApiV1AdminBillingCyclesGet_4(organizationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getCyclesApiV1AdminBillingCyclesGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve chartable credit usage history for a specific organization.
         * @summary Get organization billing history
         * @param {string} organizationId Target organization ID
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string | null} [agentId] Optional agent filter
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoryApiV1AdminBillingHistoryGet(organizationId: string, startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoryApiV1AdminBillingHistoryGet(organizationId, startTime, endTime, window, agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getHistoryApiV1AdminBillingHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve chartable credit usage history for a specific organization.
         * @summary Get organization billing history
         * @param {string} organizationId Target organization ID
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string | null} [agentId] Optional agent filter
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoryApiV1AdminBillingHistoryGet_5(organizationId: string, startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoryApiV1AdminBillingHistoryGet_5(organizationId, startTime, endTime, window, agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getHistoryApiV1AdminBillingHistoryGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of individual call usage records for a specific organization.
         * @summary Get organization call usage records
         * @param {string} organizationId 
         * @param {number} [limit] Page size
         * @param {number} [offset] Pagination offset
         * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortByEnum} [sortBy] Sort field
         * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortDirectionEnum} [sortDirection] asc or desc
         * @param {string | null} [startTime] Filter: only records with started_at &gt;&#x3D; this (UTC)
         * @param {string | null} [endTime] Filter: only records with started_at &lt; this (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet(organizationId: string, limit?: number, offset?: number, sortBy?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortByEnum, sortDirection?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortDirectionEnum, startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrgUsageListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet(organizationId, limit, offset, sortBy, sortDirection, startTime, endTime, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of individual call usage records for a specific organization.
         * @summary Get organization call usage records
         * @param {string} organizationId 
         * @param {number} [limit] Page size
         * @param {number} [offset] Pagination offset
         * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortByEnum} [sortBy] Sort field
         * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortDirectionEnum} [sortDirection] asc or desc
         * @param {string | null} [startTime] Filter: only records with started_at &gt;&#x3D; this (UTC)
         * @param {string | null} [endTime] Filter: only records with started_at &lt; this (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet_6(organizationId: string, limit?: number, offset?: number, sortBy?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortByEnum, sortDirection?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortDirectionEnum, startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrgUsageListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet_6(organizationId, limit, offset, sortBy, sortDirection, startTime, endTime, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve paginated billing status for all organizations.
         * @summary Get per-organization billing status
         * @param {number} [limit] Page size
         * @param {number} [offset] Page offset
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsApiV1AdminBillingOrganizationsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBillingOrganizationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsApiV1AdminBillingOrganizationsGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getOrganizationsApiV1AdminBillingOrganizationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve paginated billing status for all organizations.
         * @summary Get per-organization billing status
         * @param {number} [limit] Page size
         * @param {number} [offset] Page offset
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsApiV1AdminBillingOrganizationsGet_7(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBillingOrganizationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsApiV1AdminBillingOrganizationsGet_7(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getOrganizationsApiV1AdminBillingOrganizationsGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve aggregated billing metrics across all organizations.
         * @summary Get platform-wide billing overview
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOverviewApiV1AdminBillingOverviewGet(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBillingOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOverviewApiV1AdminBillingOverviewGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getOverviewApiV1AdminBillingOverviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve aggregated billing metrics across all organizations.
         * @summary Get platform-wide billing overview
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOverviewApiV1AdminBillingOverviewGet_8(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBillingOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOverviewApiV1AdminBillingOverviewGet_8(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getOverviewApiV1AdminBillingOverviewGet_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the top-up purchase ledger for a specific organization.
         * @summary Get organization top-up ledger
         * @param {string} organizationId Target organization ID
         * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
         * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopUpsApiV1AdminBillingTopUpsGet(organizationId: string, startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingTopUpListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopUpsApiV1AdminBillingTopUpsGet(organizationId, startTime, endTime, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getTopUpsApiV1AdminBillingTopUpsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the top-up purchase ledger for a specific organization.
         * @summary Get organization top-up ledger
         * @param {string} organizationId Target organization ID
         * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
         * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopUpsApiV1AdminBillingTopUpsGet_9(organizationId: string, startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingTopUpListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopUpsApiV1AdminBillingTopUpsGet_9(organizationId, startTime, endTime, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.getTopUpsApiV1AdminBillingTopUpsGet_9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update organization billing allowance
         * @param {string} organizationId 
         * @param {AdminBillingOrgUpdateRequest} adminBillingOrgUpdateRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch(organizationId: string, adminBillingOrgUpdateRequest: AdminBillingOrgUpdateRequest, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBillingOrgEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch(organizationId, adminBillingOrgUpdateRequest, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update organization billing allowance
         * @param {string} organizationId 
         * @param {AdminBillingOrgUpdateRequest} adminBillingOrgUpdateRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch_10(organizationId: string, adminBillingOrgUpdateRequest: AdminBillingOrgUpdateRequest, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBillingOrgEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch_10(organizationId, adminBillingOrgUpdateRequest, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBillingApi.updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch_10']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminBillingApi - factory interface
 * @export
 */
export const AdminBillingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminBillingApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a top-up for an organization
         * @param {string} organizationId 
         * @param {AdminCreateTopUpRequest} adminCreateTopUpRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost(organizationId: string, adminCreateTopUpRequest: AdminCreateTopUpRequest, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingTopUpEntry> {
            return localVarFp.createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost(organizationId, adminCreateTopUpRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a top-up for an organization
         * @param {string} organizationId 
         * @param {AdminCreateTopUpRequest} adminCreateTopUpRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost_1(organizationId: string, adminCreateTopUpRequest: AdminCreateTopUpRequest, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingTopUpEntry> {
            return localVarFp.createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost_1(organizationId, adminCreateTopUpRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve aggregated billing history across all organizations.
         * @summary Get cross-organization billing history
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregateHistoryApiV1AdminBillingHistoryAggregateGet(startTime: string, endTime: string, window?: AggregationWindow, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminBillingAggregateHistoryResponse> {
            return localVarFp.getAggregateHistoryApiV1AdminBillingHistoryAggregateGet(startTime, endTime, window, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve aggregated billing history across all organizations.
         * @summary Get cross-organization billing history
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAggregateHistoryApiV1AdminBillingHistoryAggregateGet_2(startTime: string, endTime: string, window?: AggregationWindow, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminBillingAggregateHistoryResponse> {
            return localVarFp.getAggregateHistoryApiV1AdminBillingHistoryAggregateGet_2(startTime, endTime, window, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the credit balance for a specific organization. Optionally specify cycle_start to get historical balance.
         * @summary Get organization billing balance
         * @param {string} organizationId Target organization ID
         * @param {string | null} [cycleStart] Cycle start for historical balance (ISO 8601 UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceApiV1AdminBillingBalanceGet(organizationId: string, cycleStart?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingBalanceResponse> {
            return localVarFp.getBalanceApiV1AdminBillingBalanceGet(organizationId, cycleStart, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the credit balance for a specific organization. Optionally specify cycle_start to get historical balance.
         * @summary Get organization billing balance
         * @param {string} organizationId Target organization ID
         * @param {string | null} [cycleStart] Cycle start for historical balance (ISO 8601 UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBalanceApiV1AdminBillingBalanceGet_3(organizationId: string, cycleStart?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingBalanceResponse> {
            return localVarFp.getBalanceApiV1AdminBillingBalanceGet_3(organizationId, cycleStart, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all billing cycles for a specific organization, most recent first.
         * @summary List billing cycles
         * @param {string} organizationId Target organization ID
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCyclesApiV1AdminBillingCyclesGet(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingCyclesResponse> {
            return localVarFp.getCyclesApiV1AdminBillingCyclesGet(organizationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all billing cycles for a specific organization, most recent first.
         * @summary List billing cycles
         * @param {string} organizationId Target organization ID
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCyclesApiV1AdminBillingCyclesGet_4(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingCyclesResponse> {
            return localVarFp.getCyclesApiV1AdminBillingCyclesGet_4(organizationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve chartable credit usage history for a specific organization.
         * @summary Get organization billing history
         * @param {string} organizationId Target organization ID
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string | null} [agentId] Optional agent filter
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryApiV1AdminBillingHistoryGet(organizationId: string, startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingHistoryResponse> {
            return localVarFp.getHistoryApiV1AdminBillingHistoryGet(organizationId, startTime, endTime, window, agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve chartable credit usage history for a specific organization.
         * @summary Get organization billing history
         * @param {string} organizationId Target organization ID
         * @param {string} startTime Start time in ISO 8601 format (UTC)
         * @param {string} endTime End time in ISO 8601 format (UTC)
         * @param {AggregationWindow} [window] Aggregation window for history buckets
         * @param {string | null} [agentId] Optional agent filter
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryApiV1AdminBillingHistoryGet_5(organizationId: string, startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingHistoryResponse> {
            return localVarFp.getHistoryApiV1AdminBillingHistoryGet_5(organizationId, startTime, endTime, window, agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of individual call usage records for a specific organization.
         * @summary Get organization call usage records
         * @param {string} organizationId 
         * @param {number} [limit] Page size
         * @param {number} [offset] Pagination offset
         * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortByEnum} [sortBy] Sort field
         * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortDirectionEnum} [sortDirection] asc or desc
         * @param {string | null} [startTime] Filter: only records with started_at &gt;&#x3D; this (UTC)
         * @param {string | null} [endTime] Filter: only records with started_at &lt; this (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet(organizationId: string, limit?: number, offset?: number, sortBy?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortByEnum, sortDirection?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortDirectionEnum, startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrgUsageListResponse> {
            return localVarFp.getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet(organizationId, limit, offset, sortBy, sortDirection, startTime, endTime, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of individual call usage records for a specific organization.
         * @summary Get organization call usage records
         * @param {string} organizationId 
         * @param {number} [limit] Page size
         * @param {number} [offset] Pagination offset
         * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortByEnum} [sortBy] Sort field
         * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortDirectionEnum} [sortDirection] asc or desc
         * @param {string | null} [startTime] Filter: only records with started_at &gt;&#x3D; this (UTC)
         * @param {string | null} [endTime] Filter: only records with started_at &lt; this (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet_6(organizationId: string, limit?: number, offset?: number, sortBy?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortByEnum, sortDirection?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortDirectionEnum, startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrgUsageListResponse> {
            return localVarFp.getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet_6(organizationId, limit, offset, sortBy, sortDirection, startTime, endTime, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve paginated billing status for all organizations.
         * @summary Get per-organization billing status
         * @param {number} [limit] Page size
         * @param {number} [offset] Page offset
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsApiV1AdminBillingOrganizationsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminBillingOrganizationsResponse> {
            return localVarFp.getOrganizationsApiV1AdminBillingOrganizationsGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve paginated billing status for all organizations.
         * @summary Get per-organization billing status
         * @param {number} [limit] Page size
         * @param {number} [offset] Page offset
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsApiV1AdminBillingOrganizationsGet_7(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminBillingOrganizationsResponse> {
            return localVarFp.getOrganizationsApiV1AdminBillingOrganizationsGet_7(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve aggregated billing metrics across all organizations.
         * @summary Get platform-wide billing overview
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverviewApiV1AdminBillingOverviewGet(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminBillingOverviewResponse> {
            return localVarFp.getOverviewApiV1AdminBillingOverviewGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve aggregated billing metrics across all organizations.
         * @summary Get platform-wide billing overview
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOverviewApiV1AdminBillingOverviewGet_8(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminBillingOverviewResponse> {
            return localVarFp.getOverviewApiV1AdminBillingOverviewGet_8(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the top-up purchase ledger for a specific organization.
         * @summary Get organization top-up ledger
         * @param {string} organizationId Target organization ID
         * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
         * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopUpsApiV1AdminBillingTopUpsGet(organizationId: string, startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingTopUpListResponse> {
            return localVarFp.getTopUpsApiV1AdminBillingTopUpsGet(organizationId, startTime, endTime, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the top-up purchase ledger for a specific organization.
         * @summary Get organization top-up ledger
         * @param {string} organizationId Target organization ID
         * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
         * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopUpsApiV1AdminBillingTopUpsGet_9(organizationId: string, startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BillingTopUpListResponse> {
            return localVarFp.getTopUpsApiV1AdminBillingTopUpsGet_9(organizationId, startTime, endTime, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update organization billing allowance
         * @param {string} organizationId 
         * @param {AdminBillingOrgUpdateRequest} adminBillingOrgUpdateRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch(organizationId: string, adminBillingOrgUpdateRequest: AdminBillingOrgUpdateRequest, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminBillingOrgEntry> {
            return localVarFp.updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch(organizationId, adminBillingOrgUpdateRequest, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update organization billing allowance
         * @param {string} organizationId 
         * @param {AdminBillingOrgUpdateRequest} adminBillingOrgUpdateRequest 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch_10(organizationId: string, adminBillingOrgUpdateRequest: AdminBillingOrgUpdateRequest, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminBillingOrgEntry> {
            return localVarFp.updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch_10(organizationId, adminBillingOrgUpdateRequest, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminBillingApi - object-oriented interface
 * @export
 * @class AdminBillingApi
 * @extends {BaseAPI}
 */
export class AdminBillingApi extends BaseAPI {
    /**
     * 
     * @summary Create a top-up for an organization
     * @param {string} organizationId 
     * @param {AdminCreateTopUpRequest} adminCreateTopUpRequest 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost(organizationId: string, adminCreateTopUpRequest: AdminCreateTopUpRequest, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost(organizationId, adminCreateTopUpRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a top-up for an organization
     * @param {string} organizationId 
     * @param {AdminCreateTopUpRequest} adminCreateTopUpRequest 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost_1(organizationId: string, adminCreateTopUpRequest: AdminCreateTopUpRequest, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).createTopUpApiV1AdminBillingOrganizationsOrganizationIdTopUpsPost_1(organizationId, adminCreateTopUpRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve aggregated billing history across all organizations.
     * @summary Get cross-organization billing history
     * @param {string} startTime Start time in ISO 8601 format (UTC)
     * @param {string} endTime End time in ISO 8601 format (UTC)
     * @param {AggregationWindow} [window] Aggregation window for history buckets
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getAggregateHistoryApiV1AdminBillingHistoryAggregateGet(startTime: string, endTime: string, window?: AggregationWindow, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getAggregateHistoryApiV1AdminBillingHistoryAggregateGet(startTime, endTime, window, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve aggregated billing history across all organizations.
     * @summary Get cross-organization billing history
     * @param {string} startTime Start time in ISO 8601 format (UTC)
     * @param {string} endTime End time in ISO 8601 format (UTC)
     * @param {AggregationWindow} [window] Aggregation window for history buckets
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getAggregateHistoryApiV1AdminBillingHistoryAggregateGet_2(startTime: string, endTime: string, window?: AggregationWindow, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getAggregateHistoryApiV1AdminBillingHistoryAggregateGet_2(startTime, endTime, window, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the credit balance for a specific organization. Optionally specify cycle_start to get historical balance.
     * @summary Get organization billing balance
     * @param {string} organizationId Target organization ID
     * @param {string | null} [cycleStart] Cycle start for historical balance (ISO 8601 UTC)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getBalanceApiV1AdminBillingBalanceGet(organizationId: string, cycleStart?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getBalanceApiV1AdminBillingBalanceGet(organizationId, cycleStart, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the credit balance for a specific organization. Optionally specify cycle_start to get historical balance.
     * @summary Get organization billing balance
     * @param {string} organizationId Target organization ID
     * @param {string | null} [cycleStart] Cycle start for historical balance (ISO 8601 UTC)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getBalanceApiV1AdminBillingBalanceGet_3(organizationId: string, cycleStart?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getBalanceApiV1AdminBillingBalanceGet_3(organizationId, cycleStart, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all billing cycles for a specific organization, most recent first.
     * @summary List billing cycles
     * @param {string} organizationId Target organization ID
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getCyclesApiV1AdminBillingCyclesGet(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getCyclesApiV1AdminBillingCyclesGet(organizationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all billing cycles for a specific organization, most recent first.
     * @summary List billing cycles
     * @param {string} organizationId Target organization ID
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getCyclesApiV1AdminBillingCyclesGet_4(organizationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getCyclesApiV1AdminBillingCyclesGet_4(organizationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve chartable credit usage history for a specific organization.
     * @summary Get organization billing history
     * @param {string} organizationId Target organization ID
     * @param {string} startTime Start time in ISO 8601 format (UTC)
     * @param {string} endTime End time in ISO 8601 format (UTC)
     * @param {AggregationWindow} [window] Aggregation window for history buckets
     * @param {string | null} [agentId] Optional agent filter
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getHistoryApiV1AdminBillingHistoryGet(organizationId: string, startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getHistoryApiV1AdminBillingHistoryGet(organizationId, startTime, endTime, window, agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve chartable credit usage history for a specific organization.
     * @summary Get organization billing history
     * @param {string} organizationId Target organization ID
     * @param {string} startTime Start time in ISO 8601 format (UTC)
     * @param {string} endTime End time in ISO 8601 format (UTC)
     * @param {AggregationWindow} [window] Aggregation window for history buckets
     * @param {string | null} [agentId] Optional agent filter
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getHistoryApiV1AdminBillingHistoryGet_5(organizationId: string, startTime: string, endTime: string, window?: AggregationWindow, agentId?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getHistoryApiV1AdminBillingHistoryGet_5(organizationId, startTime, endTime, window, agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of individual call usage records for a specific organization.
     * @summary Get organization call usage records
     * @param {string} organizationId 
     * @param {number} [limit] Page size
     * @param {number} [offset] Pagination offset
     * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortByEnum} [sortBy] Sort field
     * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortDirectionEnum} [sortDirection] asc or desc
     * @param {string | null} [startTime] Filter: only records with started_at &gt;&#x3D; this (UTC)
     * @param {string | null} [endTime] Filter: only records with started_at &lt; this (UTC)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet(organizationId: string, limit?: number, offset?: number, sortBy?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortByEnum, sortDirection?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortDirectionEnum, startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet(organizationId, limit, offset, sortBy, sortDirection, startTime, endTime, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of individual call usage records for a specific organization.
     * @summary Get organization call usage records
     * @param {string} organizationId 
     * @param {number} [limit] Page size
     * @param {number} [offset] Pagination offset
     * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortByEnum} [sortBy] Sort field
     * @param {GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortDirectionEnum} [sortDirection] asc or desc
     * @param {string | null} [startTime] Filter: only records with started_at &gt;&#x3D; this (UTC)
     * @param {string | null} [endTime] Filter: only records with started_at &lt; this (UTC)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet_6(organizationId: string, limit?: number, offset?: number, sortBy?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortByEnum, sortDirection?: GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortDirectionEnum, startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet_6(organizationId, limit, offset, sortBy, sortDirection, startTime, endTime, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve paginated billing status for all organizations.
     * @summary Get per-organization billing status
     * @param {number} [limit] Page size
     * @param {number} [offset] Page offset
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getOrganizationsApiV1AdminBillingOrganizationsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getOrganizationsApiV1AdminBillingOrganizationsGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve paginated billing status for all organizations.
     * @summary Get per-organization billing status
     * @param {number} [limit] Page size
     * @param {number} [offset] Page offset
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getOrganizationsApiV1AdminBillingOrganizationsGet_7(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getOrganizationsApiV1AdminBillingOrganizationsGet_7(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve aggregated billing metrics across all organizations.
     * @summary Get platform-wide billing overview
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getOverviewApiV1AdminBillingOverviewGet(authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getOverviewApiV1AdminBillingOverviewGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve aggregated billing metrics across all organizations.
     * @summary Get platform-wide billing overview
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getOverviewApiV1AdminBillingOverviewGet_8(authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getOverviewApiV1AdminBillingOverviewGet_8(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the top-up purchase ledger for a specific organization.
     * @summary Get organization top-up ledger
     * @param {string} organizationId Target organization ID
     * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
     * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getTopUpsApiV1AdminBillingTopUpsGet(organizationId: string, startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getTopUpsApiV1AdminBillingTopUpsGet(organizationId, startTime, endTime, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the top-up purchase ledger for a specific organization.
     * @summary Get organization top-up ledger
     * @param {string} organizationId Target organization ID
     * @param {string | null} [startTime] Optional purchased_at start filter (UTC)
     * @param {string | null} [endTime] Optional purchased_at end filter (UTC)
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public getTopUpsApiV1AdminBillingTopUpsGet_9(organizationId: string, startTime?: string | null, endTime?: string | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).getTopUpsApiV1AdminBillingTopUpsGet_9(organizationId, startTime, endTime, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update organization billing allowance
     * @param {string} organizationId 
     * @param {AdminBillingOrgUpdateRequest} adminBillingOrgUpdateRequest 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch(organizationId: string, adminBillingOrgUpdateRequest: AdminBillingOrgUpdateRequest, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch(organizationId, adminBillingOrgUpdateRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update organization billing allowance
     * @param {string} organizationId 
     * @param {AdminBillingOrgUpdateRequest} adminBillingOrgUpdateRequest 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminBillingApi
     */
    public updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch_10(organizationId: string, adminBillingOrgUpdateRequest: AdminBillingOrgUpdateRequest, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminBillingApiFp(this.configuration).updateOrganizationApiV1AdminBillingOrganizationsOrganizationIdPatch_10(organizationId, adminBillingOrgUpdateRequest, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortByEnum = {
    StartedAt: 'started_at',
    FinishedAt: 'finished_at',
    Duration: 'duration'
} as const;
export type GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortByEnum = typeof GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortByEnum[keyof typeof GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortByEnum];
/**
 * @export
 */
export const GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortDirectionEnum = typeof GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortDirectionEnum[keyof typeof GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGetSortDirectionEnum];
/**
 * @export
 */
export const GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortByEnum = {
    StartedAt: 'started_at',
    FinishedAt: 'finished_at',
    Duration: 'duration'
} as const;
export type GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortByEnum = typeof GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortByEnum[keyof typeof GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortByEnum];
/**
 * @export
 */
export const GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortDirectionEnum = typeof GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortDirectionEnum[keyof typeof GetOrgUsageApiV1AdminBillingOrganizationsOrganizationIdUsageGet0SortDirectionEnum];
